export default {
  icon: 'person',
  name: 'Personnes',
  noItems:
    "Aucun résultat en relation avec l'organisation et les filtres sélectionnés",
  tabs: {
    user_exchanges: 'Echanges',
    infos: 'Infos',
    description: 'Description',
  },
  fields: {
    author_original_id: 'author_original_id',
    city: 'Ville',
    end_date: 'Date de fin',
    id: 'ID',
    name: 'Nom',
    nav_full_id: 'nav_full_id',
    organisation: 'Entité',
    postal_code: 'Code postal',
    staff_function: 'Fonction',
    staff_job: 'Job',
    staff_type: 'type',
    temp_worker: 'Sous-traitant',
    type: "Type d'auteur",
  },
  type: {
    customer: 'Client',
    group: 'Génésis',
    staff: 'Employé',
  },
};
